module.exports = __webpack_public_path__ + "static/media/Corded_ware_icon.6ac19a23.png";